import { UserSettingChangeEmailPage } from "@/features/user-setting/pages/UserSettingChangeEmailPage";

const UserSettingChangeEmail = () => {
  return <UserSettingChangeEmailPage />;
};

export default UserSettingChangeEmail;
